import { createAction, props } from '@ngrx/store';

export const GetMeToMember = createAction('[Checkbooks: Actions]: Get Me To Member', props<{ loyaltyMemberId: any }>());

export const OpenDialogForUnassignCheckbook = createAction('[Checkbooks: Actions]: Open Dialog For Unassign Checkbook');

export const UnassignCheckbook = createAction(
  '[Checkbooks: Actions]: Unassign Checkbook',
  props<{ selectedRow: any }>(),
);

export const UnassignCheckbookSuccess = createAction(
  '[Checkbooks: Actions]: Unassign Checkbook Success',
  props<{ response: any }>(),
);

export const UnassignCheckbookFailed = createAction(
  '[Checkbooks: Actions]: Unassign Checkbook Failed',
  props<{ error: any }>(),
);

export const RedirectToMemberPageSuccess = createAction('[Checkbooks: Actions]: Redirect Member Page Success');

export const RedirectToMemberPageFailed = createAction(
  '[Checkbooks: Actions]: Redirect Member Page Failed',
  props<{ error: string }>(),
);

export const AssignSelectedCheckbookDetailsData = createAction(
  '[Checkbooks: Actions]: Assign Selected Checkbook Code',
  props<{ selectedCheckbookDetailsData: any[] }>(),
);
